export const validateAdditionalOptionFields = (filters) => {
  const fieldNames = [
    'additional_milgrain',
    'hand_engraving',
    'special_finish'
  ]

  return fieldNames.filter(e => filters[e] === null)
}



// WEBPACK FOOTER //
// ./src/containers/jewelry/validations/additional-option-fields/index.js